const allColors = {
  dark: '#19222a',
  white: '#FFFFFF',
  offWhite: '#FCFEFE',
  slate: '#465e74',
  coolBlue: '#40aec2',
  darkCoolBlue: '#197286',
  darkTwo: '#19222a',
  darkGreyBlue: '#334454',
  darkBlue: '#13191f',
  mediumGrey: '#c9d4df',
  innerBlue: '#1c262f',
  red: '#ff0000',
  yellow: '#ffaa00',
  green: '#009900',
  activeThumb: '#FFFFFF',
  active: '#009900',
  inactiveThumb: '#334454',
  inactive: '#13191f',
  modalBackgroundColor: '#26333f',
  tangaroa: '#1f2b35',
};

export default allColors;
